import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-excel': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM260 224H231.2C226.8 224 222.8 226.4 220.7 230.3 202.7 263.4 198.5 272.7 192.1 288 178.2 258.9 185.2 270.7 163.5 230.3 161.4 226.4 157.3 224 152.9 224H124C114.7 224 109 234 113.6 242L159.9 320 113.6 398C108.9 406 114.7 416 124 416H152.9C157.3 416 161.3 413.6 163.4 409.7 185.1 369.7 186.4 364.7 192 352 206.9 382.2 197.9 367.9 220.6 409.7 222.7 413.6 226.8 416 231.2 416H260C269.3 416 275 406 270.4 398L224 320C224.7 318.9 254.3 269.5 270.3 242 275 234 269.2 224 260 224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-excel.js
// module id = KH5k
// module chunks = 144